import { CheckInput } from '@octano/global-ui';
import { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../../locales/translations';
import { FinantialSettingsContext } from '../contexts/finantial-settings.context';
import { FinantialConfig } from '../interfaces/finantial-config.interface';

const prefix = 'equivalenceCredit';

export default function EquivalenceCreditSection() {
  const { t } = useTranslation(TranslationsKeys.CONFIGURATION_FINANTIAL);
  const finantialSettingsContext = useContext(FinantialSettingsContext);
  const { control } = useFormContext<FinantialConfig>();

  return (
    <Row className="mt-4">
      <Col xs={12}>
        <h2 className="text-primary fs-16 fw-600 text-uppercase mb-4">
          {t(`${prefix}.title`)}
        </h2>
      </Col>
      <Col sm={12}>
        <CheckInput
          control={control}
          disabled={finantialSettingsContext.disabled}
          name="hasEquivalenceCredit"
          label={t(`${prefix}.inputs.hasEquivalenceCredit`)}
        />
      </Col>
    </Row>
  );
}
